import Vue from 'vue'
import { Empty, Skeleton, Loading } from 'vant'
Vue.use(Empty)
  .use(Skeleton)
  .use(Loading)
